import { defineMasterdataEntity } from '../types/masterdata-entity-definition';
import { MasterdataCurrency } from '../types/masterdata-entities';

export const MASTERDATA_CURRENCY = defineMasterdataEntity<MasterdataCurrency>({
  name: 'currency',
  responseKey: 'currencies',
  displayWith: (c) =>
    c.isoCode && c.isoCode !== c.key ? `${c.key} (${c.isoCode})` : c.key,
  icon: 'fa-regular fa-coins',
  title: 'Währungssuche',
  label: 'Währung',
  placeholder: 'Währung suchen...',
  columns: [
    {
      label: 'Währung',
      type: 'entity',
      icon: 'fa-regular fa-coins',
      value: (c) =>
        c.isoCode && c.isoCode !== c.key ? `${c.key} (${c.isoCode})` : c.key,
    },
    { label: 'Schlüssel', value: (c) => c.key },
    { label: 'ISO-Code', value: (c) => c.isoCode },
    { label: 'Kurs', value: (c) => c.exchangeRate },
    { label: 'Nachkommastellen', value: (c) => c.valueDecimals },
    { label: 'Rechenkommastellen', value: (c) => c.calculationDecimals },
    { label: 'Fixkurs', value: (c) => (c.fixed ? 'Ja' : 'Nein') },
  ],
});
